import { render } from "./About.vue?vue&type=template&id=0f38e17c&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=0f38e17c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f38e17c"

export default script